import {IValidateBase} from "./IValidateBase";
import {Component} from "react";
import {IValidationResult} from "./IValidationResult";
import {store} from "../../redux/storeConfig/store";
import {dataUtils} from "../js/dataUtils";

//import {applyoo} from "../../App";

export class AP_Validation_Required extends Component implements IValidateBase {

    validateCode = "AP_Validation_Required";
    validateName = "AP_Validation_Required";

    Validate =  (prmElement:any)=> {
        //const intl = useIntl();

        let outObj:IValidationResult = {
            isError: false,
            errorMessage: prmElement?.ExtendedParamsObj?.Validations?.AP_Validation_Required?.ErrorMessage? dataUtils.parseLangKey(prmElement?.ExtendedParamsObj?.Validations?.AP_Validation_Required?.ErrorMessage) : "Title_MandatoryField",
            ElementGuid: prmElement.ElementGuid,
        }

        if (prmElement?.ExtendedParamsObj?.Validations?.AP_Validation_Required?.IsEnabled) {
            let pageData = store.getState().store_PageData.data;
            //let currData = store.getState().store_PageData.data[prmElement.DataBindStr];

            let elementValue = dataUtils.getNestedJsonValue(pageData,prmElement.DataBindStr); //APPLYOO.config.Elements[prmElement.ElementTypeCode].getValue(prmElement);


            if (elementValue == undefined || elementValue == null || elementValue == ""){//|| elementValue == ""
                outObj.isError = true;
            }

            // if (elementValue == null || elementValue.length == 0) {
            //
            //     outObj.isError = true;
            // }
        }

        return outObj;
    }
}